export enum ServiceRequestSubject {
  PaymentChange = 'PAYMENT_CHANGE',
  Other = 'OTHER',
  Revocation = 'REVOCATION',
  Unknown = 'UNKNOWN',
  Termination = 'TERMINATION',
  PersonalData = 'PERSONAL_DATA',
}
